// extracted by mini-css-extract-plugin
export var body = "WMT6xu6l3yl55cDXllG4";
export var hero = "JApmtfyfVUt_utYEfFRC";
export var large = "GQqwl_BWc1wQ4ipYa1zh";
export var micro = "GAl61kuFi8TWIN3Am2kE";
export var mini = "KXObzsncRTZv6yuj0ZHw";
export var small = "vuyAdkvLFMxImdtywkuv";
export var title1 = "HVo9SNd609CIPLYqKfqp";
export var title2 = "lCKA7ju3uJUB4hRafrAy";
export var title3 = "sp17CX5IZ2ICjlpoeNMx";